import React, { useState } from "react";
import styled from "styled-components";
import mq from "../../../helpers/media-queries";
import { rem } from "polished";
import Arrow from "../../../assets/img/arrow.png";
import Cube from "../../../assets/img/cube.png";
import DetailsModal from "../../DetailsModal/DetailsModal";

const Wrap = styled.div`
	background-color: #fff;
	width: auto;
	height: 47px;
	position: absolute;
	bottom: 18px;
	left: 50%;
	transform: translateX(-50%);
	border: 0.87037px solid #ededed;
	border-radius: 43.5185px;
	display: flex;
	align-items: center;
	padding: 0 ${rem(25)};

	${mq("sm", "max")} {
		display: none;
	}
`;
const Button = styled.button`
	background-color: inherit;
	border: 0;
	font-weight: 400;
	font-size: ${rem(13)};
	line-height: 1.3;
	display: flex;
	align-items: center;
	cursor: pointer;

	img {
		height: ${rem(17)};
		margin-right: ${rem(19)};
	}
`;
const Line = styled.div`
	width: 1px;
	height: 21px;
	background: #dbdbdb;
	margin: 0 22px;
`;

const Qr = styled.div`
	position: absolute;
	width: 257px;
	bottom: 80px;
	right: 0;
	background-color: #fff;
	border-radius: 20px;
	padding: ${rem(40)};
	padding-top: ${rem(38)};
	text-align: center;
	font-family: sans-serif;
	border: 0.87037px solid #ededed;
	cursor: pointer;
	font-size: 13.0556px;
	line-height: 1.3;

	img {
		width: 100%;
		max-width: 100%;
		margin-bottom: ${rem(12)};
	}
`;

const galleryData = {
	details: {
		items: [
			{
				title: "Chimney Heat Guard",
				subtitle: "FLUE & DRAIN",
				text: "Relax with complete peace of mind. Surrounding the flue, this cost-effective safety add-on prevents injury from accidental contact with the chimney.",
				video: "https://www.youtube.com/embed/LfluICo7tPY",
			},
		],
	},
};
const PopupTabs = ({videoUrl, qrCode}) => {
	const [showQr, setShowQr] = useState(false);
	const [modalIsOpen, setIsOpen] = useState(false);

	function toggleQr() {
		setShowQr(!showQr);
	}

	return (
		<Wrap>
			<Button onClick={() => setIsOpen(!modalIsOpen)}>
				<img src={Arrow} alt="" /> Play Video
			</Button>
			<Line />
			<Button onClick={toggleQr}>
				<img src={Cube} alt="" /> See it in your garden
			</Button>

			<Qr style={showQr ? { display: "block" } : { display: "none" }}>
				<img src={qrCode} alt="" />
				<p>Point your smart phone camera here</p>
			</Qr>
			<DetailsModal
				{...galleryData.details}
				open={modalIsOpen}
				modalToggle={() => setIsOpen(!modalIsOpen)}
				type="video"
				videoUrl={videoUrl}
			/>
		</Wrap>
	);
};

export default PopupTabs;
